module.exports = __webpack_public_path__ + "static/media/galerija_2014 (17).6b4a89b6.jpg";